import React from "react"
import { Button as GatsbyButton } from "gatsby-theme-material-ui"
import Button from "@mui/material/Button"
import { contrastBrandPalette } from "../utils/colours"

export const ButtonContactUs = props => {
  return (
    <GatsbyButton
      variant="contained"
      to="/contact-st-ewe"
      sx={{
        backgroundColor: contrastBrandPalette["Rich Yolk Primary"]?.value,
        "&:hover": {
          backgroundColor: contrastBrandPalette["Original Primary"]?.value,
        },
        fontSize: "clamp(1.188rem, 2vw + 1rem, 1.25rem) !important",
        marginLeft: "auto",
      }}
      {...props}
    >
      Contact Us
    </GatsbyButton>
  )
}
